import {
  GridActionsCellItem,
  GridActionsCellItemProps,
  GridColDef,
} from "@mui/x-data-grid";

import { ReactElement } from "react";
import DeleteSKUContainer from "../components/DeleteSKUContainer";

export const useSKUsTableColumns = (): {
  columns: GridColDef[];
} => {
  const columns: GridColDef[] = [
    {
      field: "skuNumber",
      headerName: "SKU Number",
      minWidth: 160,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
    },
    {
      field: "configurationName",
      headerName: "Configuration",
      minWidth: 200,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
    },
    {
      field: "category",
      headerName: "Category",
      minWidth: 120,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      renderCell: params => {
        const value = params.value;

        if (!value) return "-";

        return value.charAt(0).toUpperCase() + value.slice(1);
      },
    },
    {
      field: "nodeCount",
      headerName: "Nodes",
      minWidth: 80,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      renderCell: params => params.value ?? 0,
    },
    {
      field: "skuDataConfigurations",
      headerName: "Devices",
      minWidth: 350,
      flex: 1,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      renderCell: params => {
        const value = params.value;
        try {
          const data = typeof value === "string" ? JSON.parse(value) : value;

          if (!Array.isArray(data)) return "Invalid Data";

          const countForEachDevice: Record<string, number> = {};

          data.forEach((item: any) => {
            if (item?.deviceType) {
              countForEachDevice[item.deviceType] =
                (countForEachDevice[item.deviceType] || 0) + 1;
            }
          });

          const listOfDevices = Object.entries(countForEachDevice)
            .map(([deviceType, count]) => `${deviceType} (${count})`)
            .join(", ");

          return listOfDevices;
        } catch (e) {
          return "Invalid Data";
        }
      },
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 100,
      disableColumnMenu: true,
      hideable: false,
      sortable: false,
      type: "actions",
      width: 100,
      getActions: (params): ReactElement<GridActionsCellItemProps>[] => [
        <GridActionsCellItem
          key={`delete-${params.row?.rowId}`}
          icon={<DeleteSKUContainer row={params.row} />}
          label="Delete"
          className="actionButton"
          disableRipple
        />,
      ],
    },
  ];

  return { columns };
};
